export enum SortFields {
  Name = 'name',
  Account = 'account',
  Site = 'site',
}
export enum SortDirs {
  Asc = 'asc',
  Desc = 'desc',
}
